import _ from 'lodash';
import $ from 'jquery';
import {hexToRgb} from 'app/lib/colors';
import theme from "./theme";

let config = {};

export const settings = {
    defaultLocale: 'en',
    supportedLocales: ['en', 'nl', 'de', 'fr'],
    basename: typeof document !== 'undefined' && document.baseURI ? document.baseURI.replace(document.location.origin, '') : $('html > head > base').attr('href')
};

export const setConfig = (cnf) => {
    config = cnf;
    buildAPIRoutes();
};

export const versionCheckInterval = () => {
    return config.versionCheckInterval || 6000;
};

const getValidationFromConfig = (key) => {
    return (config && config.validation && config.validation[key]) || {}
}

export const getValidationLicensePlateMinLength = () => {
    const licensePlate = getValidationFromConfig('licensePlate');
    return licensePlate.minLength || 6;
}

export const getValidationLicensePlateMaxLength = () => {
    const licensePlate = getValidationFromConfig('licensePlate');
    return licensePlate.maxLength || 12;
}

export const registrationUrl = () => config.registrationUrl;

export let apiRoutes = {
    GET_CONFIG:         getAppUrl('config.json'),
    GET_STATS:          getAppUrl('asset-manifest.json'),
    GET_TRANSLATIONS:   getAppUrl('assets/i18n'),
    GET_PROFILE:        getAppUrl('api-mock/profile.json')
};

export const colors = theme;
export const colorsRGB = convertAllHexToRGB(colors);

export const UNIT_KINDS = {
    CONTAINER: " ",
    SWAP_BODY: "C",
    NON_ISO: "F",
    TRAILER: "P"
};

function getAPIUrl(path) {
    if (process.env.REACT_APP_MOCK) {
        return 'api-mock/' + path + '.json';
    }

    return config.api + '/api/' + path;
    // return GLOBAL.api + '/api/' + path;
}

function buildAPIRoutes() {
    apiRoutes = Object.assign(apiRoutes, {

        GET_TIME_SLOTS:     _.template(getAPIUrl('timeslots/${ slotEta }?dom=${ dom }&days=${ days }')),

        USER_LOGIN:         getAPIUrl('login'),
        USER_REFRESH_LOGIN: getAPIUrl('login/refresh'),
        GET_COMPANY_DATA:   getAPIUrl('company'),

        GET_VISITS:         getAPIUrl('visits/filter'),
        GET_VISIT:          _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }')),
        GET_VISIT_UNITS:    _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }/units')),
        PUT_VISIT:          _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }')),
        DELETE_VISIT:       _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }')),
        SUBMIT_VISIT:       _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }/submit')),
        POST_VISIT:         getAPIUrl('visits'),

        POST_UNIT:          _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }/units')),
        PUT_UNIT:           _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }/units/${ utrac }')),
        DELETE_UNIT:        _.template(getAPIUrl('visits/${ vtrac.toLowerCase() }/units/${ utrac }')),
        VERIFY_UNIT:        getAPIUrl('units/verify'),

        GET_GOODS:          _.template(getAPIUrl('units/${ utrac.toLowerCase() }/goods')),
        PUT_GOOD:           _.template(getAPIUrl('units/${ utrac.toLowerCase() }/goods/${ trac }')),
        POST_GOOD:          _.template(getAPIUrl('units/${ utrac.toLowerCase() }/goods')),
        DELETE_GOOD:        _.template(getAPIUrl('units/${ utrac.toLowerCase() }/goods/${ id }')),

        GET_DOCS:          _.template(getAPIUrl('units/${ utrac.toLowerCase() }/docs')),
        PUT_DOC:           _.template(getAPIUrl('units/${ utrac.toLowerCase() }/docs/${ trac }')),
        POST_DOC:          _.template(getAPIUrl('units/${ utrac.toLowerCase() }/docs')),
        DELETE_DOC:        _.template(getAPIUrl('units/${ utrac.toLowerCase() }/docs/${ id }')),

        UPLOAD_DOC:        _.template(getAPIUrl('attach/doc/${ id }')),
        DOWNLOAD_FILE:     _.template(getAPIUrl('attach/item/${ id }')),
        DELETE_FILE:       _.template(getAPIUrl('attach/item/${ id }')),

        ACTUAL_TRUCKS:     _.template(getAPIUrl('reports/actualtrucks?dom=${ dom }&date=${ date }')),
        ACTUAL_LEAD_TIME:  _.template(getAPIUrl('reports/actualleadtime?dom=${ dom }')),
        ACTUAL_OCCUPANCY:  _.template(getAPIUrl('reports/actualtimeslotoccupancy?dom=${ dom }&date=${ date }')),
        AVERAGE_LEAD_TIME: _.template(getAPIUrl('reports/avgtimeslotleadtime?dom=${ dom }&dayOfWeek=${ dayOfWeek }')),

        RAIL_STATUS_IN:    _.template(getAPIUrl('reports/railstatus?type=1&dom=${ dom }')),
        RAIL_STATUS_OUT:   _.template(getAPIUrl('reports/railstatus?type=2&dom=${ dom }'))
    });
}

function getAppUrl(path) {
    return settings.basename + path;
}

function convertAllHexToRGB(colors) {
    let rgbColors = {};
    _.each(colors, (color, colorName) => {
        rgbColors[colorName] = hexToRgb(color);
    });
    return rgbColors;
}
